interface Urls {
  home: string;
  concur: string;
  facilities: string;
  technology: string;
  travel: string;
  teamrec: string;
  site: string;
  reserve: string;
  people: string;
  copilot: string;
  notifications: string;
  mytickets: string;
  knowledge: string;
}

export const urls: Urls = {
  home: "/",
  concur: "https://forms.office.com/Pages/ResponsePage.aspx?id=XWFrIh0ilkSZqjQAvR_-7i_gqTXtgbFEkNq_J_oKg_9UNjdDTE8zR0dRWEJXTFpJS09WMVE3VTJDTS4u",
  facilities:
    "https://forms.office.com/Pages/ResponsePage.aspx?id=XWFrIh0ilkSZqjQAvR_-7r21kg5RAnVOh63LrWSv5xVUMElHTjJCTlg1MTdaMExYQ0pFMlhPVk1aWSQlQCN0PWcu",
  technology:
    "https://servicenow.golubcapital.com/gc?id=sc_cat_item&sys_id=1fdb4b0efb35165002abf8a605efdcdb",
  travel:
    "https://servicenow.golubcapital.com/gc?id=sc_cat_item&sys_id=61f72f691b69b150833385d8cd4bcb03",
  teamrec: "https://forms.office.com/r/6tzLd5veKF",
  site: "https://forms.office.com/pages/responsepage.aspx?id=XWFrIh0ilkSZqjQAvR_-7oJ0xiXqFh5PnFYQkvu4Fn5UOEpBSFAzWEZWTkdPMDM1N1lGWkNIUkVQUCQlQCN0PWcu",
  reserve: "https://golubcapital.cadm.com/login?route=101",
  people: "https://golubcapital.cadm.com/login?route=201",
  copilot:
    "https://forms.office.com/pages/responsepage.aspx?id=XWFrIh0ilkSZqjQAvR_-7ihl_dm5E6xGk9us7cq3N9FUNFM2OUlUUkcwNlc0QVVHUUozVUNNVzMxMy4u&route=shorturl",
  notifications: "/",
  mytickets: "https://servicenow.golubcapital.com/gc",
  knowledge: "https://golubcapital.sharepoint.com/sites/knowledgecenter",
};
